<template>
  <div class="min-h-screen bg-gray-50">
    <Nav />

    <!-- Top Articles 标题 -->
    <div class="text-center my-8 sm:my-12 px-4">
      <h2 class="text-2xl sm:text-3xl font-airstrip text-gray-600">
        top articles
      </h2>
    </div>

    <!-- 主要内容区域 -->
    <div class="container mx-auto px-4 pb-8 sm:pb-12 max-w-[1400px]">
      <div
        class="flex flex-col lg:flex-row gap-6 lg:gap-8 justify-center items-start"
      >
        <!-- 左侧：博客卡片 - 占据更多空间 -->
        <div class="w-full lg:flex-1">
          <PostCard />
        </div>

        <!-- 右侧：个人资料 - 固定宽度 -->
        <div class="w-full lg:w-[320px] lg:flex-shrink-0">
          <SiderProfile />
        </div>
      </div>
    </div>

    <!-- Topic Cards -->
    <div class="mt-8 sm:mt-12">
      <TopicCard />
    </div>
  </div>
</template>

<script>
import "@/styles/index.css";
import Nav from "@/components/nav.vue";
import SiderProfile from "@/components/siderProfile.vue";
import PostCard from "@/components/postCard.vue";
import TopicCard from "@/components/topicCard.vue";

export default {
  name: "Index",
  components: {
    Nav,
    SiderProfile,
    PostCard,
    TopicCard,
  },
};
</script>
